document.addEventListener("DOMContentLoaded", () => {
  const menu = new MmenuLight(
    document.querySelector("#menu"),
    "(max-width: 950px)"
  );

  menu.navigation({
    title: "Nomad Internet",
    theme: "dark"
  });

  const drawer = menu.offcanvas({
    position: "right"
  });

  document
    .querySelector("#nav-toggler")
    .addEventListener("click", (e) => {
      e.preventDefault();
      drawer.open();
    });

  let lastScrollY = window.scrollY;
  const header = document.querySelector('#shopify-section-header');

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY && currentScrollY > 80) {
      header.classList.add('header-hidden');
    } else {
      header.classList.remove('header-hidden');
    }

    lastScrollY = currentScrollY;
  });
});
